/* beautiful-react-hooks version: 0.31.1 */
var isApiSupported = function isApiSupported(api) {
  return typeof window !== 'undefined' ? api in window : false;
};

export default isApiSupported;
